import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

import TableRow from './TableRow.vue'
import TableCell from './TableCell.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'TableRowSkeleton',
  props: {
    columns: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
    return _createVNode(TableRow, { key: i }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (j) => {
          return (_openBlock(), _createBlock(TableCell, { key: j }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("td", { class: "py-0 max-h-[69px]" }, [
                _createElementVNode("div", { class: "grid gap-2" }, [
                  _createElementVNode("div", { class: "skeleton-shine h-3 w-32 rounded bg-gray-800" }),
                  _createElementVNode("div", { class: "skeleton-shine h-3 w-16 rounded bg-gray-800" })
                ])
              ], -1)
            ])),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 2
    }, 1024)
  }), 64))
}
}

})